<template>
    <tr>
        <td>
            <router-link :to="orderDetailsLink"
            >#{{ returnItem.RODOONUM }}</router-link>
        </td>
        <!-- <td>{{ returnItem.RODOONUM }}</td> -->
        <td>{{ returnItem.ROOESM + '/' + returnItem.ROOESD + '/' + returnItem.ROOESY }}</td>
        <td>{{ returnItem.ERRDSC }}</td>
        <td>${{ returnItem.QEXTPRC }}</td>
        <td class="text-right">
            <!-- <svg width="25" height="25" viewBox="0 0 32 32" class="cart-X-svg cart-table__remove" @click="removeItem">
                <path d="M25.313 9.229l-7.438 7.438 7.438 7.438-1.875 1.875-7.438-7.438-7.438 7.438-1.875-1.875 7.438-7.438-7.438-7.438 1.875-1.875 7.438 7.438 7.438-7.438z"></path>
            </svg> -->
        </td>
        <td><router-link :to="orderDetailsLink" class="btn btn-xs btn-primary">View Details</router-link></td>
    </tr>
</template>

<script>

export default {
    props: {
        returnItem: {
            type: Object,
            required: true
        },
    },
    computed: {
        orderDetailsLink() {
            // return this.$route.path + '/' + this.returnItem.RODOONUM;
            return '/return-items/' + this.returnItem.RODOONUM;
        },
    },
    methods:  {
        removeItem() {
            this.$emit('remove_item',  this.returnItem.RODOONUM);
        }
    }
}
</script>